import React, { useMemo } from 'react'
import * as ScreenPermissions from 'core/EventActions'
import { hasAccesPermits } from 'core/utils'
import { Route } from 'react-router-dom'
import ACAUniType from './ACAUnitType'
import ACACausecode from './ACACausecode'
import ACACParameter from './ACAParameter'
import ACASeason from './ACASeason'
import ACAAvgStat from './ACAAvgStat'
import ACAUnits from './ACAUnits'
import ACaUnitCapbility from './ACAUnitsCapability'
import Anlph from './ACAnplh'

const AEPAcaSppReportRouteNav = ({ actionPermits }) => {
  const adminPermission = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits: actionPermits,
        eventActions: [ScreenPermissions.AEP_ACA_SPP_DATA_READ],
        matchAny: true,
      }),
    [actionPermits]
  )

  if (!adminPermission) {
    return <React.Fragment />
  }
  return (
    <React.Fragment>
      <Route
        exact
        key="aep-acap-spp-report-unittype"
        path="/acap/unittype"
        component={ACAUniType}
      />
      <Route
        exact
        key="aep-acap-spp-report-causecode"
        path="/acap/causecode"
        component={ACACausecode}
      />
      <Route
        exact
        key="aep-acap-spp-report-parameter"
        path="/acap/parameter"
        component={ACACParameter}
      />
      <Route
        exact
        key="aep-acap-spp-report-seasons"
        path="/acap/seasons"
        component={ACASeason}
      />
      <Route
        exact
        key="aep-acap-spp-report-cl-avg-stat"
        path="/acap/cl-avg-stat"
        component={ACAAvgStat}
      />
      <Route
        exact
        key="aep-acap-spp-report-units"
        path="/acap/units"
        component={ACAUnits}
      />
      <Route
        exact
        key="aep-acap-spp-verf-cap"
        path="/acap/verf-cap"
        component={ACaUnitCapbility}
      />
      <Route
        exact
        key="aep-acap-spp-anplh"
        path="/acap/anplh"
        component={Anlph}
      />
    </React.Fragment>
  )
}

export { AEPAcaSppReportRouteNav }
